(() => {
  const MTO = () => {
    document.querySelectorAll('.clickyboxes').forEach(($clickyBoxes) => {
      // remove variant selection by default
      $clickyBoxes.querySelectorAll('.active').forEach(($active) => {
        $active.classList.remove('active');
      });

      // size availability
      $clickyBoxes.querySelectorAll('a').forEach(($size) => {
        let size = $size.dataset.value;
        let $optionWrapper = $size.closest('.option-selectors');
        let $select = $optionWrapper.querySelector('select');
        let $optionSize = $select.querySelector(`option[value="${ size }"]`);
        if ($optionWrapper.classList.contains('option-selectors-instock')) {
          $size.classList.toggle('disabled', JSON.parse($optionSize.dataset.disable));
          $size.closest('li').classList.toggle('soldout', JSON.parse($optionSize.dataset.disable));
        }
      });

      // show size selection with click
      $clickyBoxes.addEventListener('click', (e) => {
        let $formWrap = e.target.closest('.product-detail__form');
        let $form = $formWrap.querySelector('form');

        // if soldout, do nothing
        if (e.target.classList.contains('soldout')) return;

        // remove all size selections
        $formWrap.querySelectorAll('a.active').forEach(($item) => {
          $item.classList.remove('active');
        });

        if (e.target.dataset.value) {
          // show current size selection
          e.target.classList.add('active');
        }

        // add line item prop to product form
        let $optionWrapper = e.target.closest('.options-wrap');
        let ship_info = $optionWrapper.querySelector('.lineitem-prop').value;
        let $formLineProp = $form.querySelector('[data-prop]');
        if ($formLineProp) {
          $formLineProp.remove();
        }
        $form.insertAdjacentHTML('beforeend',`<input data-prop type="hidden" name="properties[Shipping Info]" value="${ ship_info }" />`)
      });
    });

    let $formContainer = document.querySelector('.product-detail__form');

    let UpdateAtcBtn = () => {
      let $atcBtn = $formContainer.querySelector('button[name=add]');
      let isSizeSelected = $atcBtn.classList.contains('size-selected');
      $atcBtn.disabled = !isSizeSelected;
      $atcBtn.textContent = !isSizeSelected ? 'Select Size' : 'Add To Cart';
    }

    if ($formContainer) {
      UpdateAtcBtn();
    }
  }
  window.onload = MTO;
})();